
export enum UserRole {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  USER = 'USER'
}

export enum BetOutcome {
  GREEN = 'GREEN',
  RED = 'RED',
  REFUND = 'REFUND',
  PENDING = 'PENDING'
}

export interface League {
  id: string;
  name: string;
  created_at?: string;
}

export interface Player {
  id: string;
  name: string;
  league_id: string;
  created_at?: string;
}

export interface Market {
  id: string;
  name: string;
  created_at?: string;
}

export interface Bet {
  id: string;
  user_id: string;
  league_id: string;
  player1_id: string;
  player2_id: string;
  market_id: string;
  stake: number;
  odd: number;
  outcome: BetOutcome;
  date: string;
  profit?: number;
  player1_goals?: number;
  player2_goals?: number;
  created_at?: string;
}

export interface User {
  id: string;
  name: string;
  role: UserRole;
  active: boolean;
  whatsapp?: string;
  email?: string;
  avatar_url?: string;
  subscription_expires_at?: string;
}

export interface AppState {
  currentUser: User;
  users: User[];
  leagues: League[];
  players: Player[];
  markets: Market[];
  bets: Bet[];
}
